/**
 * Centralized route registry.
 *
 * Aggregates per-module route definitions into a single array that
 * <AppRoutes /> iterates over.  Adding a new module is a one-liner.
 */
import farmerRoutes from 'modules/farmer/routes';
import adminRoutes  from 'modules/admin/routes';
import agentRoutes  from 'modules/agent/routes';
import vendorRoutes from 'modules/vendor/routes';
// Future: import aicRoutes from 'modules/aic/routes';

const allProtectedRoutes = [
  ...farmerRoutes,
  ...adminRoutes,
  ...agentRoutes,
  ...vendorRoutes,
];

export default allProtectedRoutes;
